import { useCallback, useState } from 'react'

import { UseVisibilityStateResult } from './types'

const useVisibilityState = (): UseVisibilityStateResult => {
  const [isVisible, setIsVisible] = useState(false)

  const showItem = useCallback(() => setIsVisible(true), [])
  const hideItem = useCallback(() => setIsVisible(false), [])

  return [isVisible, showItem, hideItem]
}

export default useVisibilityState
